import { render, staticRenderFns } from "./organizationlist.vue?vue&type=template&id=4c7280ad"
import script from "./organizationlist.vue?vue&type=script&lang=js"
export * from "./organizationlist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports